import script from "./courseInfoDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./courseInfoDetail.vue?vue&type=script&setup=true&lang=js"

import "./courseInfoDetail.vue?vue&type=style&index=0&id=a516db9e&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a516db9e"]])

export default __exports__